import { createNullableProvideInject } from '@collector/shared-ui'

import { AddIncidentConfig } from '../configuration'

export const [provideAddIncidentConfig, injectAddIncidentConfig] =
  createNullableProvideInject<AddIncidentConfig>('addIncidentConfig')
